// Login.jsx — PC con auto-redirección a móvil
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

axios.defaults.baseURL = "https://backend.sansfrontieres-design.com";
axios.defaults.withCredentials = false;

const BG_URL = "/img/login-bg.jpg";
const LOGO_URL = "/img/firma.png";

// ===== styles (iguales) =====
const page = { minHeight: "100vh", display: "grid", placeItems: "center", padding: 24, position: "relative", overflow: "hidden" };
const bgBlur = { position: "absolute", inset: 0, backgroundImage: `url('${BG_URL}')`, backgroundSize: "cover", backgroundPosition: "center", filter: "blur(6px) brightness(0.92)", transform: "scale(1.04)", zIndex: 0 };
const cornerLogo = { position: "absolute", top: 28, left: 40, zIndex: 3 };
const logoStyle = { height: 100, objectFit: "contain", mixBlendMode: "multiply", filter: "saturate(1.05) contrast(1.02)", userSelect: "none" };
const flowingBrand = { position: "absolute", top: 30, right: 42, zIndex: 3, display: "flex", alignItems: "center", gap: 11, color: "#f4f4f4", userSelect: "none", textShadow: "0 1px 8px rgba(0,0,0,.45)" };
const flowingIcon = { position: "relative", width: 26, height: 24, flex: "0 0 26px" };
const flowingSquare = { position: "absolute", width: 8, height: 8, borderRadius: 2, background: "#f4f4f4", boxShadow: "0 1px 4px rgba(0,0,0,.3)" };
const flowingText = { fontSize: 27, lineHeight: 1, fontWeight: 600, letterSpacing: 0.1 };
const panel = { width: "min(980px, 96vw)", display: "grid", gridTemplateColumns: "360px 1fr", gap: 24, padding: 24, background: "rgba(68, 76, 84, .65)", border: "1px solid rgba(255,255,255,.08)", borderRadius: 20, boxShadow: "0 20px 60px rgba(0,0,0,.35)", backdropFilter: "blur(10px)", position: "relative", zIndex: 1 };
const formBox = { background: "rgba(110, 145, 145, .92)", border: "1px solid rgba(0,0,0,.15)", borderRadius: 12, padding: 16, boxShadow: "inset 0 0 0 1px rgba(255,255,255,.08)" };
const label = { fontSize: 13, margin: "8px 0 4px", color: "#1f2c2c" };
const input = { width: "100%", height: 36, borderRadius: 8, border: "1px solid rgba(0,0,0,.25)", padding: "0 10px", outline: "none", background: "white" };
const button = { width: "100%", height: 38, border: 0, borderRadius: 8, marginTop: 12, cursor: "pointer", background: "#e7c8ba", color: "#222" };
const rightCol = { display: "grid", placeItems: "center", color: "#e8e8e8" };
const hr = { height: 1, width: "72%", background: "rgba(255,255,255,.25)", margin: "14px auto" };
const footer = { position: "absolute", bottom: 8, left: 0, right: 0, textAlign: "center", color: "rgba(255,255,255,0.9)", fontSize: 12, zIndex: 1 };

const MOBILE_MQ = "(max-width: 820px)";
const isMobile = () =>
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
  (typeof window !== "undefined" && window.matchMedia && window.matchMedia(MOBILE_MQ).matches);

const norm = (v) => String(v || "").toLowerCase().replace(/\s+/g, "");
const getWorkfun = (u = {}) => norm(u.workfun ?? u.Workfun ?? u.WorkFun ?? u.workFun ?? "");

function setLoggedWorker(u){
  try {
    const json = JSON.stringify(u);
    sessionStorage.setItem("loggedWorker", json);
    localStorage.setItem("loggedWorker", json);
    if (typeof window !== "undefined") window.__loggedWorker = u;
  } catch {}
}

export default function Login() {
  const [wid, setWid] = useState("");
  const [wpass, setWpass] = useState("");
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  // 🔁 Auto-switch: si es móvil, manda a /login-mobile (también cuando cambias a responsive)
  useEffect(() => {
    const goMobile = () => {
      if (isMobile()) nav("/login-mobile", { replace: true });
    };
    goMobile(); // chequeo inicial
    const mql = window.matchMedia(MOBILE_MQ);
    mql.addEventListener?.("change", goMobile);
    window.addEventListener("resize", goMobile);
    return () => {
      mql.removeEventListener?.("change", goMobile);
      window.removeEventListener("resize", goMobile);
    };
  }, [nav]);

  const submit = async () => {
    if (loading) return;
    if (!wid || !wpass) { setMsg("Enter your WorkID and Workpass"); return; }
    setLoading(true); setMsg("");

    try {
      delete axios.defaults.headers.common["X-Login-User"];
      delete axios.defaults.headers.common["x-login-user"];

      const payload = new URLSearchParams({ workid: wid.trim(), workpass: wpass }).toString();
      const res = await axios.post("/login_worker.php", payload, {
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        validateStatus: () => true,
        withCredentials: false,
      });

      const data = res?.data || {};
      if (data.status === "success") {
        const u = data.data || {};
        setLoggedWorker(u);

        const widNow = String(u.workid || u.Workid || "").trim();
        if (widNow) axios.defaults.headers.common["X-Login-User"] = widNow;

        const wf = getWorkfun(u);
        const target = wf.includes("draft") ? "/drafter" : "/hola-admin";
        await Promise.resolve();
        nav(target, { replace: true });
      } else {
        setMsg(data.message || `Incorrect credentials`);
      }
    } catch (err) {
  console.error("LOGIN NETWORK ERROR:", {
    message: err?.message,
    code: err?.code,
    name: err?.name,
    status: err?.response?.status,
    statusText: err?.response?.statusText,
    data: err?.response?.data,
    url: err?.config?.url,
    baseURL: err?.config?.baseURL,
  });

  const detail =
    err?.response?.status
      ? `HTTP ${err.response.status} ${err.response.statusText || ""}`
      : err?.code || err?.message || "network error";

  setMsg(`Error: ${detail}`);
} finally {
      setLoading(false);
    }
  };

  const onKey = (e) => { if (e.key === "Enter") submit(); };

  return (
    <div style={page}>
      <div aria-hidden style={bgBlur} />
      <div style={cornerLogo}>
        <img src={LOGO_URL} alt="Sans Frontières Design" style={logoStyle} onError={(e) => (e.currentTarget.style.display = "none")} />
      </div>
      <div style={flowingBrand} aria-label="Flowing">
        <span style={flowingIcon} aria-hidden="true">
          <span style={{ ...flowingSquare, left: 0, bottom: 0 }} />
          <span style={{ ...flowingSquare, left: 13, bottom: 0 }} />
          <span style={{ ...flowingSquare, left: 13, top: 0 }} />
        </span>
        <span style={flowingText}>Flowing</span>
      </div>
      <div style={panel}>
        <div style={formBox}>
          <div style={label}>User</div>
          <input style={input} placeholder="WorkID" value={wid} onChange={(e) => setWid(e.target.value)} onKeyDown={onKey} autoFocus />
          <div style={label}>Password</div>
          <input style={input} type="password" placeholder="Workpass" value={wpass} onChange={(e) => setWpass(e.target.value)} onKeyDown={onKey} />
          <button style={button} onClick={submit} disabled={loading}>{loading ? "Verifying..." : "Login"}</button>
          <div style={{ marginTop: 8, color: "crimson", minHeight: 20 }}>{msg}</div>
        </div>
        <div style={rightCol}>
          <div style={{ textAlign: "center" }}>
            <div style={{ fontSize: 38, fontWeight: 600, letterSpacing: 0.5, margin: "6px 0 8px" }}>Login Design</div>
            <div style={hr} />
            <div style={{ opacity: 0.9, fontSize: 12, lineHeight: 1.9 }}>
              Forgot your password?
              <br />
              Don’t have an account? Sign up
              <div style={{ marginTop: 10 }}>&lt; Back</div>
            </div>
          </div>
        </div>
      </div>
      <div style={footer}>Created by NelsonSQC © V.2.9</div>
    </div>
  );
}
